import React from 'react';
import { Button, Text } from '@fragments';
import { IconX } from '@tabler/icons-react';
import { ArtPreview } from '../../../../features/ArtEditor';
import './styles.scss';

// What frames the prompt of an art, as chips above the field: the template picked in the
// gallery (its thumbnail) on the home, or the layers a chat edit is scoped to.
export default function ArtToken({ label, icon = null, preview = null, onRemove, removeLabel }) {
  return <span className="studio-art-token" role="group" aria-label={label} title={label}>
    {preview ? <span className="studio-art-token__thumb"><ArtPreview document={preview} rounded={false} /></span> : icon && <span className="studio-art-token__icon">{icon}</span>}
    <Text.caption weight={500} contrast={9} className="studio-art-token__label">{label}</Text.caption>
    <Button className="studio-art-token__remove" variant="text" color="overlay" size="micro" preventLoading icon={<IconX />} aria-label={removeLabel} tooltip={removeLabel} onClick={onRemove} />
  </span>;
}
